// extracted by mini-css-extract-plugin
export default {"block":"inf_blo_2hYsp","separator":"inf_sep_2QdJX","endOfPage":"inf_end_1c4P5"};